import React, { useState, useCallback } from 'react'
import { useHistory, useRouteMatch } from 'react-router-dom'
import { makeStyles } from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import { helpManifest } from './helpManifest'

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%'
  },
  header: {
    padding: 'var(--dim-3) var(--dim-4)',
    borderBottom: '1px solid var(--color-neutral-300)',
    display: 'flex',
    alignItems: 'center',
    gap: 'var(--dim-2)'
  },
  headerTitle: {
    fontSize: 'var(--font-size-md)',
    fontWeight: 'var(--font-weight-bold)'
  },
  nav: {
    flex: 1,
    overflow: 'auto',
    padding: 'var(--dim-2) 0'
  },
  sectionHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: 'var(--dim-1)',
    padding: 'var(--dim-2) var(--dim-3)',
    cursor: 'pointer',
    fontWeight: 'var(--font-weight-bold)',
    fontSize: 'var(--font-size-sm)',
    color: 'var(--color-neutral-800)',
    userSelect: 'none',
    background: 'none',
    border: 'none',
    width: '100%',
    textAlign: 'left',
    font: 'inherit',
    '&:hover': {
      background: 'var(--color-neutral-100)'
    }
  },
  sectionIcon: {
    fontSize: '18px',
    color: 'var(--color-neutral-600)'
  },
  articleLink: {
    display: 'block',
    padding: 'var(--dim-1) var(--dim-3) var(--dim-1) var(--dim-6)',
    fontSize: 'var(--font-size-sm)',
    color: 'var(--color-neutral-700)',
    cursor: 'pointer',
    textDecoration: 'none',
    background: 'none',
    border: 'none',
    borderLeft: '2px solid transparent',
    width: '100%',
    textAlign: 'left',
    font: 'inherit',
    '&:hover': {
      background: 'var(--color-neutral-100)',
      color: 'var(--color-neutral-900)'
    }
  },
  articleLinkActive: {
    color: 'var(--color-primary)',
    fontWeight: 'var(--font-weight-bold)',
    borderLeftColor: 'var(--color-primary)',
    background: 'var(--color-neutral-50)'
  }
}))

function HelpSidebar () {
  const classes = useStyles()
  const history = useHistory()
  const { url } = useRouteMatch()
  const [expanded, setExpanded] = useState(() => {
    const initial = {}
    helpManifest.forEach(section => { initial[section.slug] = true })
    return initial
  })

  const currentPath = history.location.pathname
  const basePath = url.endsWith('/') ? url.slice(0, -1) : url

  const toggleSection = useCallback((slug) => {
    setExpanded(prev => ({ ...prev, [slug]: !prev[slug] }))
  }, [])

  const navigateTo = useCallback((slug) => {
    history.push(`${basePath}/${slug}`)
  }, [history, basePath])

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <span className={classes.headerTitle}>Help</span>
      </div>
      <nav className={classes.nav}>
        {helpManifest.map(section => (
          <div key={section.slug}>
            <button
              type='button'
              className={classes.sectionHeader}
              onClick={() => toggleSection(section.slug)}
              aria-expanded={!!expanded[section.slug]}
            >
              {expanded[section.slug]
                ? <ExpandMoreIcon className={classes.sectionIcon} />
                : <ChevronRightIcon className={classes.sectionIcon} />}
              {section.title}
            </button>
            {expanded[section.slug] && section.children?.map(article => {
              const articlePath = `${basePath}/${article.slug}`
              const isActive = currentPath === articlePath

              return (
                <button
                  type='button'
                  key={article.slug}
                  className={`${classes.articleLink} ${isActive ? classes.articleLinkActive : ''}`}
                  onClick={() => navigateTo(article.slug)}
                  aria-current={isActive ? 'page' : undefined}
                >
                  {article.title}
                </button>
              )
            })}
          </div>
        ))}
      </nav>
    </div>
  )
}

export default HelpSidebar
